import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function CategoryIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12918_64136" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12918_64136)"><path d="M6.525 10.85L12.025 2L17.525 10.85H6.525ZM17.65 22C16.4167 22 15.3833 21.5833 14.55 20.75C13.7167 19.9167 13.3 18.8833 13.3 17.65C13.3 16.4167 13.7167 15.3833 14.55 14.55C15.3833 13.7167 16.4167 13.3 17.65 13.3C18.8833 13.3 19.9167 13.7167 20.75 14.55C21.5833 15.3833 22 16.4167 22 17.65C22 18.8833 21.5833 19.9167 20.75 20.75C19.9167 21.5833 18.8833 22 17.65 22ZM3 21.375V13.775H10.6V21.375H3ZM17.652 20.5C18.4507 20.5 19.125 20.2243 19.675 19.673C20.225 19.1215 20.5 18.4465 20.5 17.648C20.5 16.8493 20.2243 16.175 19.673 15.625C19.1215 15.075 18.4465 14.8 17.648 14.8C16.8493 14.8 16.175 15.0757 15.625 15.627C15.075 16.1785 14.8 16.8535 14.8 17.652C14.8 18.4507 15.0757 19.125 15.627 19.675C16.1785 20.225 16.8535 20.5 17.652 20.5ZM4.5 19.875H9.1V15.275H4.5V19.875ZM9.225 9.35H14.825L12.025 4.825L9.225 9.35Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}